// toSorted method
if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function (compareFn) {
    return [...this].sort(compareFn);
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (n) {
    n = Math.trunc(n) || 0;

    if (n < 0) n += this.length;
    if (n < 0 || n >= this.length) return undefined;

    return this[n];
  };
}

if (!Array.prototype.findLast) {
  Array.prototype.findLast = function <T>(
    this: T[],
    callback: (value: T, index: number, array: T[]) => boolean,
    thisArg?: never
  ): T | undefined {
    if (this == null) {
      throw new TypeError('Array.prototype.findLast called on null or undefined');
    }
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    const array = Object(this);
    const length = array.length >>> 0;

    for (let i = length - 1; i >= 0; i--) {
      if (i in array) {
        const value = array[i];
        if (callback.call(thisArg, value, i, array)) {
          return value;
        }
      }
    }

    return undefined;
  };
}

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    if (typeof replacement !== 'string') {
      return this.replace(search, replacement);
    }
    if (typeof search === 'string') {
      return this.split(search).join(replacement);
    }
    return this.replace(search, replacement);
  };
}
